import { render, staticRenderFns } from "./ProductEditor.vue?vue&type=template&id=774ff48d&scoped=true&"
import script from "./ProductEditor.vue?vue&type=script&lang=js&"
export * from "./ProductEditor.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditor.vue?vue&type=style&index=0&id=774ff48d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774ff48d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('774ff48d')) {
      api.createRecord('774ff48d', component.options)
    } else {
      api.reload('774ff48d', component.options)
    }
    module.hot.accept("./ProductEditor.vue?vue&type=template&id=774ff48d&scoped=true&", function () {
      api.rerender('774ff48d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/product/ProductEditor.vue"
export default component.exports